import { Image } from '@chakra-ui/react';
import { Button, Heading, Text, VStack } from 'components/ui';
import HeaderNav from '../HeaderNav/HeaderNav';
import { ScrollingText } from '../LandingPage/ScrollingText';
import { PlanDisplay } from './PlanDisplay';
import { MobileReviewsCarousel } from '../ui/MobileReviewsCarousel';
import styled from '@emotion/styled';
import { StripePrice } from '../../types';

const foodTrackImg = '../../food-track.png';

const ImgContainer = styled('div')`
  & > div > div {
    background-position-y: 100px;
  }
`;

type Props = {
  discount: number;
  discountCode: string;
  onSelectPlan: () => void;
  plan: StripePrice;
};

export const MobilePlansPage = ({
  discount,
  discountCode,
  onSelectPlan,
  plan,
}: Props) => {
  return (
    <VStack h={'100%'}>
      <HeaderNav />

      <VStack mb={10}>
        <ScrollingText />

        <PlanDisplay
          discount={discount}
          discountCode={discountCode}
          onSelectPlan={onSelectPlan}
          plan={plan}
        />
      </VStack>

      <VStack>
        <Heading
          textStyle="heading.h2"
          color={'secondary.500'}
          textAlign={'left'}
          fontWeight={'normal'}
          mb={4}
          px={8}
        >
          You’re in good company
        </Heading>

        <MobileReviewsCarousel />
      </VStack>

      <VStack alignItems={'center'} px={8} py={16}>
        <Button bgColor={'secondary.500'} onClick={onSelectPlan}>
          <Text color={'white'} fontWeight={'medium'} px={6}>
            Claim My Membership Offer Now
          </Text>
        </Button>

        <Text
          color={'secondary.500'}
          fontWeight={'regular'}
          fontSize={'lg'}
          mt={6}
          textAlign={{ base: 'center', md: 'left' }}
        >
          Get {discount}% off forever with code{' '}
          <Text fontWeight={'bold'}>{discountCode}</Text>
        </Text>
      </VStack>

      <VStack alignItems={'center'} justifyContent={'center'}>
        <ImgContainer>
          <Image
            alt="food track image"
            objectFit={'contain'}
            boxSize={400}
            src={foodTrackImg}
          />
        </ImgContainer>
      </VStack>
    </VStack>
  );
};
